import { LazyCallableRoot } from '../utils/createLazyCallable';

export default function Callables() {
    return <LazyCallableRoot />;
}
